var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('AboutDetails'),_c('Slide'),_c('h1',[_vm._v("Our Portfolio")]),_c('Portifolio'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }